import { Get, Post } from "services";
import { ApiPath } from "paths";

export const getOrderVolumeGraph = async (body) => {
  const res = await Post(`${ApiPath.ORDER_STATUS_GRAPH(body.venueId)}`, body);
  return res;
};

export const getOrderStatusKpi = async (body) => {
  const res = await Post(`${ApiPath.ORDER_STATUS_KPI(body.venueId)}`, body);
  return res;
};

export const getOrderStatusTimeline = async ({ orderId, ...params }) => {
  const res = await Get(`${ApiPath.ORDER_STATUS_TIMELINE(orderId)}`, params);
  return res;
};
